import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';

import { HealthCheckRulesView } from './HealthCheckRulesView';
import { HealthCheckView } from './HealthCheckView';
import { useGetHealthCheckStatus } from '../../hooks/reactQuerys/HealthCheckAccessQueries';

/**
 * Einstellungen → Health Check.
 *
 * Der Reiter existierte schon, hatte aber nur die Dubletten-Bereinigung der
 * Mandanten-E-Mail-Adressen — eine datenbankweite Sache. Mit #1283 kommt der
 * vorgangsbezogene Health Check dazu. Beides gehört unter denselben Begriff,
 * ist aber fachlich verschieden, deshalb zwei Untertabs.
 *
 * Die bestehende Ansicht bleibt dabei unangetastet. Den Vorgang-Check sieht
 * nur, wer dafür freigeschaltet ist (/admin/dev/healthcheck); alle anderen
 * sehen den Reiter wie vor #1283, nur mit den Dubletten.
 */
export const HealthCheckSettingsView: React.FC = () => {
  const [tab, setTab] = useState(0);
  const { isHealthCheckEnabled } = useGetHealthCheckStatus();

  if (!isHealthCheckEnabled) {
    return <HealthCheckView />;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' sx={{ px: 1, pt: 1 }}>
        Health Check
      </Typography>

      <Tabs
        value={tab}
        onChange={(_event, value: number) => setTab(value)}
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}
      >
        <Tab label='Vorgang-Check' />
        <Tab label='Dubletten' />
      </Tabs>

      {tab === 0 && <HealthCheckRulesView />}
      {tab === 1 && <HealthCheckView />}
    </Box>
  );
};
